/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_Select_Image_FileInputs */



/**
* | output |
* | --- |
* | "Please select an image file" |
*
* @param {Avatar_Select_Image_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const avatar_select_image_file = /** @type {((inputs?: Avatar_Select_Image_FileInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_Select_Image_FileInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un fichier image")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, seleccione un archivo de imagen")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Por favor, selecione um arquivo de imagem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file immagine")
	return /** @type {LocalizedString} */ ("Please select an image file")
});